module.exports = __webpack_public_path__ + "img/icon-arrow-down-xs-white.3b8e4596.svg";